import _ from 'lodash';
import {
  takeLatest, call, put,
} from 'redux-saga/effects';
import { getSavedCardsRequest, getSavedCardsResponse, setSelectedCreditCard } from '../../slices/customer';
import axios from '../axiosConfig';

function* getSavedCardsWorker({
  payload: {
    customerId,
    withAddressOnly,
  },
}) {
  try {
    const url = '/users/savedCards';
    const config = {
      method: 'post',
      url,
      data: JSON.stringify({
        customerId: customerId != null ? customerId : null,
        withAddressOnly: withAddressOnly || false,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const { data } = yield call(axios, config);
    if (data && data.length) {
      yield put(setSelectedCreditCard({
        customerId,
        selectedCard: _.find(data, (c) => c.isDefault && !c.isExpired)
          || _.find(data, (c) => !c.isExpired) || data[0],
      }));
    }
    yield put(getSavedCardsResponse({ error: !data || !data.length ? undefined : 'Could not find saved cards!', cards: data, customerId }));
  } catch (error) {
    yield put(getSavedCardsResponse({ error: 'Problem in sending request!', customerId }));
    console.error(error);
  }
}

function* getSavedCardsWatcher() {
  yield takeLatest(getSavedCardsRequest.toString(), getSavedCardsWorker);
}

export default getSavedCardsWatcher;
